<svelte:options customElement={{
  tag: 'tab-container',
  shadow: 'none',
  props: {
    tabs: { reflect: true, type: 'String' },
    activeIndex: { reflect: true, type: 'Number', attribute: 'active-index' },
    variant: { reflect: true, type: 'String' },
    stretch: { reflect: true, type: 'Boolean' }
  }
}} />

<script>
  /**
   * navi1：タブ切り替え
   * パーツライブラリ準拠の mod-tab-btns / mod-tab-item / mod-tab 構造
   * @prop {string} tabs - JSON形式のタブ一覧 '[{"label":"項目名1","content":"内容1"}]'
   * @prop {number} activeIndex - アクティブタブインデックス
   * @prop {string} variant - 'default' | 'gold' | 'gold-bottom' | 'simple'
   * @prop {boolean} stretch - タブ幅を均等に引き伸ばす
   */
  export let tabs = '[]';
  export let activeIndex = 0;
  export let variant = 'default';
  export let stretch = false;

  let parsedTabs = [];

  $: {
    try {
      parsedTabs = typeof tabs === 'string' ? JSON.parse(tabs) : (Array.isArray(tabs) ? tabs : []);
    } catch (e) {
      console.warn('TabContainer: Invalid tabs JSON', e);
      parsedTabs = [];
    }
  }

  $: btnsClass = (() => {
    switch (variant) {
      case 'gold':
        return `mod-tab-gold-btns${stretch ? ' _stretch' : ''}`;
      case 'gold-bottom':
        return `mod-tab-gold-btns _bottom${stretch ? ' _stretch' : ''}`;
      case 'simple':
        return `mod-tab-simple-btns${stretch ? ' _stretch' : ''}`;
      case 'box':
        return 'mod-tab-box-btns';
      default:
        return 'mod-tab-btns';
    }
  })();

  $: itemClass = (() => {
    switch (variant) {
      case 'gold':
      case 'gold-bottom':
        return 'mod-tab-gold-item';
      case 'simple':
        return 'mod-tab-simple-item';
      case 'box':
        return 'mod-tab-box-item';
      default:
        return 'mod-tab-item js-tab';
    }
  })();

  function switchTab(index) {
    activeIndex = index;
    const host = document.querySelector('tab-container');
    host?.dispatchEvent(new CustomEvent('tab-change', { bubbles: true, detail: { index, tab: parsedTabs[index] } }));
  }

  function handleKeydown(e, index) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      switchTab(index > 0 ? index - 1 : parsedTabs.length - 1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      switchTab(index < parsedTabs.length - 1 ? index + 1 : 0);
    }
  }
</script>

<div>
  <div class={btnsClass} role="tablist">
    {#each parsedTabs as tab, i}
      <button
        type="button"
        class={itemClass}
        class:is-active={activeIndex === i}
        role="tab"
        aria-selected={activeIndex === i}
        tabindex={activeIndex === i ? 0 : -1}
        on:click={() => switchTab(i)}
        on:keydown={(e) => handleKeydown(e, i)}
      >
        <span class="_text">{tab.label}</span>
      </button>
    {/each}
  </div>
  {#each parsedTabs as tab, i}
    <div
      class="mod-tab js-tab-content"
      class:is-active={activeIndex === i}
      class:is-visible={activeIndex === i}
      role="tabpanel"
      tabindex="0"
    >
      {@html tab.content}
    </div>
  {/each}
</div>
